import script from "./NotaryListPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./NotaryListPanel.vue?vue&type=script&setup=true&lang=js"

import "./NotaryListPanel.vue?vue&type=style&index=0&id=a50cdc24&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a50cdc24"]])

export default __exports__